import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface UserAvatarProps {
  avatarUrl?: string;
  initials: string;
  className?: string;
  fallbackClassName?: string;
}

const UserAvatar = ({ avatarUrl, initials, className, fallbackClassName }: UserAvatarProps) => (
  <Avatar className={cn('h-10 w-10', className)}>
    {avatarUrl && <AvatarImage src={avatarUrl} alt={initials} className="object-cover" />}
    <AvatarFallback className={cn('bg-secondary text-xs font-semibold text-foreground', fallbackClassName)}>
      {initials}
    </AvatarFallback>
  </Avatar>
);

export default UserAvatar;
